import { render, staticRenderFns } from "./unroadInfo.vue?vue&type=template&id=3e85d06f&scoped=true&"
import script from "./unroadInfo.vue?vue&type=script&lang=js&"
export * from "./unroadInfo.vue?vue&type=script&lang=js&"
import style0 from "./unroadInfo.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./unroadInfo.vue?vue&type=style&index=1&id=3e85d06f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e85d06f",
  null
  
)

export default component.exports